<mh-core-lib-generic-box
  customClass="tw-min-h-[{{height}}] tw-h-[{{height}}] tw-p-5 tw-flex tw-relative tw-w-full">
  @if (loading) {
    <mh-core-lib-loader-wrapper
      class="tw-w-full tw-h-full"
      [loading]="loading"
      [type]="'spinner'"
      className="tw-min-h-[180px] tw-w-full tw-flex tw-items-center tw-justify-center tw-text-4xl"></mh-core-lib-loader-wrapper>
  } @else {
    <section class="tw-flex tw-flex-col tw-h-full tw-relative tw-w-full">
      <article class="tw-w-full tw-flex-shrink-0">
        <h2 class="tw-text-base tw-font-medium tw-text-gray-900 tw-font-['Rubik']" [innerHTML]="title"></h2>
      </article>
      <article class="tw-flex-1 tw-w-full tw-flex tw-mt-2 tw-min-h-0">
        @if (items?.length > 0) {
          <ul class="tw-w-full tw-list-none tw-pl-0 tw-space-y-0.5 tw-m-0">
            @for (item of items; track item; let i = $index) {
              <li class="tw-text-base tw-leading-tight tw-flex tw-justify-between tw-gap-2 tw-text-gray-900">
                <span class="tw-flex-1">
                  {{ i + 1 }}. {{ (item.translations?.length ? (item.translations | translateObject:translationsValueKey:currentLanguage) : item.label) || item.label }}
                </span>
                @if (item.secondary) {
                  <span class="tw-text-sm tw-text-gray-700 tw-tabular-nums tw-flex-shrink-0 tw-text-right">
                    ({{ item.secondary }})
                  </span>
                }
              </li>
            }
          </ul>
        } @else {
          <div class="tw-flex tw-w-full tw-h-full tw-items-center tw-justify-center tw-min-h-[80px]">
            <p class="tw-text-center tw-font-semibold tw-text-xl tw-text-[#C4C4C4]">{{ emptyMessage }}</p>
          </div>
        }
      </article>
      @if (actionText) {
        <article class="tw-w-full tw-flex tw-justify-end tw-mt-auto tw-pt-3">
          <button
            type="button"
            (click)="viewAll.emit()"
            class="tw-font-semibold tw-font-['Rubik'] tw-uppercase tw-text-main-blue tw-text-sm tw-cursor-pointer tw-bg-transparent tw-border-none tw-p-0">
            {{ actionText }}
          </button>
        </article>
      }
    </section>
  }
</mh-core-lib-generic-box>
